import CMSPage from "@/components/CMSPage";
import { FileText } from "lucide-react";

export default function BlogPage() {
  return (
    <CMSPage
      pageId="blog"
      defaultTitle="Property News & Insights"
      defaultDescription="Stay up to date with the latest property market news, trends, and expert insights. Learn from our experienced estate agents and industry professionals."
      icon={FileText}
    />
  );
}
